export const hasToken = ({ access_token }) => !!access_token